import React from 'react'
import Downloads from 'src/app/Downloads/Downloads'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { downloadsRouteProps } from 'src/navigation/routeProps'

const DownloadsAppRoute: AppRoute = {
  routeProps: downloadsRouteProps,
  component: <Downloads />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default DownloadsAppRoute
